export default __webpack_public_path__ + "static/media/logo.d9d5c33b.svg";